/**
 * Used to select language for the player.
 *
 * @unstable
 */

import {
  Component,
  EventEmitter,
  inject,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ChangeDetectionStrategy,
} from '@angular/core';

import { LanguageData2 } from '@shared/models/locale.model';

import { LanguageManager } from '@player/shared/services/language-manager.service';
import { SurveyStore } from '@player/shared/services/survey-store.service';
import { AsyncPipe, NgClass } from '@angular/common';

@Component({
  selector: 'language-select',
  templateUrl: './language-select.component.html',
  styleUrls: ['./language-select.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [AsyncPipe, NgClass],
})
export class LanguageSelect implements OnChanges, OnInit {
  readonly lm = inject(LanguageManager);
  readonly ss = inject(SurveyStore);

  @Input() locales: {
    [lcid: string]: LanguageData2;
  };

  @Input() selected: string = null;

  @Output() select = new EventEmitter<string>();

  hover: string | null = null;

  click: string | null = null;

  languages: [string, LanguageData2][] = [];

  ngOnInit() {
    this.setLanguages();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.locales && !changes.locales.firstChange) {
      this.setLanguages();
    }
  }

  flagClass(locale: string) {
    return locale && locale.length !== 2 ? 'zef-lang-other' : `zef-lang-${locale}`;
  }

  private setLanguages(): void {
    this.languages = Object.entries(this.locales || {}).sort(([, a], [, b]) =>
      (a.native || a.name).localeCompare(b.native || b.name),
    );
  }
}
